import { commitMutation, graphql } from 'react-relay';
import Util from '../../forecast-app/shared/util/util';
import { trackEvent } from '../../tracking/amplitude/TrackingV2';
const mutation = graphql `
	mutation CreateProjectBillToMutation($input: CreateProjectBillToInput!) {
		createProjectBillTo(input: $input) {
			projectBillTo {
				node {
					id
					clientId
					clientBillToId
					billTo {
						id
						name
					}
					projectId
					billFrom {
						id
						name
						integration
					}
				}
			}
		}
	}
`;
function getConfigs(input) {
    return [
        {
            type: 'RANGE_ADD',
            parentID: input.projectId,
            connectionInfo: [
                {
                    key: 'Project_projectBillTos',
                    rangeBehavior: 'append',
                },
            ],
            edgeName: 'projectBillTo',
        },
    ];
}
function commit(environment, input, onSuccess, onError) {
    trackEvent('Project Bill To', 'Created', input);
    const variables = { input: Object.assign({ csrfToken: Util.getCsrfValue(), socketClientId: Util.getClientId() }, input) };
    return commitMutation(environment, {
        mutation,
        variables,
        configs: getConfigs(input),
        onCompleted: onSuccess,
        onError: onError,
    });
}
export default { commit };
